export const colors = {
  white: "#ffffff",
  whiteTwo: "#fafafa",
  whiteThree: "#f3f3f3",
  lightBlueGrey: " #d7dfe9",
  boulder: "#757575",
  nero: "#212121",
  darkTangerine: "#fdb51b",
  lightDarkTangerine: "#FDB51B14",
  darkGrey: "#9E9E9E",
  nightGrey: "#333333",
  acadia: "#EEEEEE",
  solitude: "#d7dfe9",
  black: "#111",
  whiteSmoke: "#f5f5f5",
  grey: "#777777",
  red: "#e61e26",
  red2: "#ec5525",
  mischka: "#b2b2b5",
  mountainMeadow: "#0FC77B",
  floralWhite: "#FFF9ED",
  gainsboro: "#e0e0e0",
  yellow: "#f9b11b",
};
